export interface PricingPlan {
  id: string
  name: string
  description: string
  targetUser: string
  features: string[]
  price: number
  billingType: 'one-time' | 'monthly'
  priceId: string // Stripe price ID
  addOns?: PricingAddOn[]
}

export interface PricingAddOn {
  id: string
  name: string
  description: string
  price: number
  priceId: string // Stripe price ID
  supportsQuantity?: boolean // Whether this add-on supports quantity selection
  maxQuantity?: number // Maximum quantity allowed
}

export interface SelectedAddOn {
  addOn: PricingAddOn
  quantity: number
}

export interface SelectedPlan {
  plan: PricingPlan
  addOns: SelectedAddOn[]
  totalPrice: number
}

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: 'real-time-sync',
    name: 'Real-Time Sync',
    description: 'Monthly Access',
    targetUser: 'Active traders and business owners',
    features: [
      'Real-time updates',
      'Everything in Batch',
      'Priority support',
      'Export anytime',
      'Advanced categorization',
      'Multiple sheets',
    ],
    price: 89,
    billingType: 'monthly',
    priceId: 'price_1SG5ANJiWItWzyyfqpeKcZ7y',
  },
  {
    id: 'batch-import',
    name: 'Batch Import',
    description: 'One Time Only Export',
    targetUser: 'Personal finance tracking',
    features: ['Up to 24 Mo of transaction history', 'Unlimited Accounts', 'Email support'],
    price: 39,
    billingType: 'one-time',
    priceId: 'price_1RddODJiWItWzyyfvAYv2XkC',
  },
]
